import { createContext, useContext, useEffect, useState } from "react";
import { registerErrorHandler } from "./errorHandler";

const ErrorContext = createContext(null)

export function ErrorProvider({ children }) {
    const [errors, setErrors] = useState([])

    useEffect(() => registerErrorHandler(pushError), [])

    const pushError = (message) => {
        if (message === 'canceled') return
        const id = Date.now()
        setErrors(prev => [...prev, {id, message}])
        setTimeout(() => removeError(id), 5000)
    }

    const removeError = (id) => {
        setErrors(prev => prev.filter(err => err.id !== id))
    }

    return(
        <ErrorContext.Provider value={{ errors, pushError, removeError}}>
            {children}
        </ErrorContext.Provider>
    )    
}

export function useErrors() {
    const context = useContext(ErrorContext)
    if (!context) throw new Error("Use Errors must be used inside the Error Provider")
    return context
}